import React, { useEffect } from "react";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import {
  PADDING_3,
  BACKGOUND_PRIMARY,
  BACKGROUND_GRAY_HOVER,
} from "../../utils/GlobalConstants";
import "./Home.css";
import Survey from "../survey/Survey";
import Import from "../import/Import";

import { addItemInCountryData } from "../../store/UpdateSurveyData";
import { useDispatch } from "react-redux";
import { getAllStates } from "../../services/SurveyRequest";
import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { ErrorBoundary } from "react-error-boundary";
import FallBack from "../../components/common/fallback/FallBack";
import { useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import Find from "../find/Find";

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={PADDING_3}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const Home = () => {
  const [value, setValue] = React.useState(0);
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const getUsStates = useCallback(async () => {
    try {
      const response = await getAllStates();

      dispatch(addItemInCountryData(response));
    } catch (e) {
      console.log(e);
    }
  }, [dispatch]);
  useEffect(() => {

    const accesstoken = Cookies.get("access_token");
    if (accesstoken) {
      navigate('/fleet/home')
    } else {
      navigate('/fleet/login')
    }
  }, [navigate])
  useEffect(() => {
    // fetchAndValidateToken(dispatch);
    getUsStates();
  }, [dispatch, getUsStates]);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <ErrorBoundary FallbackComponent={FallBack}>
      <React.Fragment>
        <div className="header-tab-container">
          <Tabs
            value={value}
            onChange={handleChange}
            aria-label="basic tabs example"
            TabIndicatorProps={{
              style: { BACKGOUND_PRIMARY },
            }}
            sx={BACKGROUND_GRAY_HOVER}
          >
            <Tab label={t(`tab1.name`)} {...a11yProps(0)} />
            <Tab label={t(`tab2.name`)} {...a11yProps(1)} />
            <Tab label={t(`tab3.name`)} {...a11yProps(2)} />
          </Tabs>
        </div>
        <CustomTabPanel value={value} index={0}>
          <Survey />
        </CustomTabPanel>
        <CustomTabPanel value={value} index={1}>
          <Import handleChangeForTab={handleChange} />
        </CustomTabPanel>
        <CustomTabPanel value={value} index={2}>
          <Find  handleChangeForTab={handleChange}/>
        </CustomTabPanel>
      </React.Fragment>
    </ErrorBoundary>
  );
};

export default Home;
